import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
export default function connect(services, mapStoreToProps, mapActionsToProps) {
    if (typeof services === 'undefined') {
        throw new Error('未设置数据源服务');
    }

    const dummyState = {};
    return function (Ele) {
        return class CompWraper extends Component {
            constructor(props, context) {
                super(props, context);
                let me = this;
                me.unsubscribes = [];
                me.services = services.map(function (service) {
                    return new service(me.context.cmp_store);
                });
            }
            static defaultProps = Ele.defaultProps
            static propsMap = Ele.propsMap || {}
            static services = services
            static contextTypes = {
                cmp_store: PropTypes.object
            }
            onChange() {
                this.setState(dummyState);
            }
            componentWillMount() {
                let me = this;
                // me.unsubscribe = me.service.subscribe(me.onChange.bind(me))
                me.unsubscribes = me.services.map(function (service) {
                    return service.subscribe(me.onChange.bind(me));
                });
            }
            componentWillUnmount() {
                let me = this;
                // me.unsubscribe && me.unsubscribe();
                if (me.unsubscribes && me.unsubscribes.length > 0) {
                    me.unsubscribes.map((func) => func());
                };
            }
            mapStoreToStateWarper() {

                let me = this;
                if (!mapStoreToProps) {
                    return me.services.reduce(function (pre, service) {
                        let state = service.getState();
                        if (Map.isMap(state)) {
                            state = state.toJS();
                        }
                        return Object.assign(pre, {
                            [service.config.key]: state
                        });
                    }, {});
                }

                let states = me.services.map(function (service) {
                    let state = service.getState();
                    if (Map.isMap(state)) {
                        state = state.toJS();
                    }
                    return state;
                });

                return mapStoreToProps.apply(me, states);
            }
            mapActionToPropsWarper() {
                let me = this;
                if (!mapActionsToProps) {
                    return me.services.reduce(function (pre, service) {
                        return Object.assign(pre, service);
                    }, {});
                }
                return mapActionsToProps.apply(me, me.services);
            }
            render() {
                let me = this;

                // if (Ele) {
                //     return <Ele 
                //     {...this.mapActionToPropsWarper() } 
                //     {...this.props.match } 
                //     {...this.mapStoreToStateWarper()} />

                // } else if (this.props.element) {
                //     let propety = {
                //         ...this.props,
                //         ...this.mapActionToPropsWarper(),
                //         ...this.mapStoreToStateWarper()
                //     }
                //     return React.createElement(this.props.element, propety, this.props.children)
                // }
                let propety = {
                    ...me.props,
                    ...me.mapActionToPropsWarper(),
                    ...me.mapStoreToStateWarper()
                };
                return React.createElement(Ele, propety, me.props.children);
            }
        };
    };
}



// WEBPACK FOOTER //
// ./_source/cqsx/services/connect.js